import { useEffect, useState } from "react";
import * as _ from "lodash";

export const getPersistState = (initialState, storeKey, omitPersistKeys = []) => {
  try {
    const persistedValue = JSON.parse(sessionStorage.getItem(`persistState:${storeKey}`));

    return (
      {
        ...initialState,
        ..._.omit(persistedValue, ...omitPersistKeys),
      } || initialState
    );
  } catch {
    sessionStorage.removeItem(`persistState:${storeKey}`);
    return initialState;
  }
};

export const setPersistState = (storeKey, value) =>
  sessionStorage.setItem(`persistState:${storeKey}`, JSON.stringify(value));

export const usePersistState = (
  initialState,
  storeKey,
  omitPersistKeys = [],
  ignorePersistance = false
  // ^ Use it when you have some logic which tries to switch the hook usePersistState/useState
  // ^ so it can be done without conditions
) => {
  const defaultValue = ignorePersistance ? initialState : getPersistState(initialState, storeKey, omitPersistKeys);
  const [state, setState] = useState(defaultValue);

  useEffect(() => {
    if (!ignorePersistance) setPersistState(storeKey, _.omit(state, ...omitPersistKeys));
  }, [storeKey, state, ignorePersistance]);

  return [state, setState];
};
